<template>
    <div class="tvview bg-light">
        <div class="container-fluid">
            <router-view
                id="fullscreen-container"
                :fullscreen="fullscreen"
                @toggle-full-screen="toggleFullscreen"
            />
        </div>
        <modalTerms ref="termsWindow" />
        <modalPrivacy ref="privacyWindow" />
        <notifications
            :width="notification.width"
            group="root"
            position="top center"
            style="top: 19vh;"
            class="shadow rounded"
        >
            <template slot="body" slot-scope="props">
                <b-alert :variant="notification.variant" show class="mb-0">
                    <div class="notification-wrapper-flex">
                        <div class="center-side">
                            <div
                                class="notification-title"
                                v-show="props.item.title"
                            >
                                {{ props.item.title }}
                            </div>
                            <div class="content-wrapper">
                                <span
                                    v-html="props.item.text"
                                    class="notification-text"
                                ></span>
                            </div>
                        </div>
                        <a
                            @click="closeNotification(props)"
                            class="close"
                            style="cursor: pointer;"
                            >&times;</a
                        >
                    </div>
                </b-alert>
            </template>
        </notifications>
    </div>
</template>
<script>
import { get, assign, clone, forEach } from "lodash";
import modalTerms from "./terms.vue";
import modalPrivacy from "./privacy.vue";
import fullscreen from "vue-fullscreen";
import ScheduleHelper from "@/module/schedule/helper";
import Vue from "vue";
Vue.use(fullscreen);
import IntercomJsSdk from "@intercom/messenger-js-sdk";

import "offline-js";

export default {
    components: {
        modalTerms,
        modalPrivacy
    },
    mixins: [ScheduleHelper],
    data() {
        return {
            currentActor: null,
            permissions: {},
            setting: {},
            timesheet: {},
            extensions: {},
            notification: {
                variant: "success",
                duration: 3000,
                width: "30%"
            },
            fullscreen: false
        };
    },
    computed: {
        year() {
            return moment().format("Y");
        }
    },
    mounted() {
        const settingLoader = [
            this.getBusinessSettings(),
            this.getCurrentStaff(),
            this.getCurrentStaffPermissions(),
            this.getActiveExtension(),
            this.$store.dispatch("loadReference"),
            this._getStatus().then(statuses => {
                this.$store.commit(
                    "status",
                    statuses.map(status => ({
                        ...status,
                        icon: this.statusClass(status.id)
                    }))
                );
            })
        ];

        Promise.all(settingLoader).then(() => {
            this.$root.$emit("settingLoaded", this.$root.setting);
            this.$store.commit("setting", { value: this.$root.setting });
            this.registerSocketIO();
        });

        //call idexx iframe modal
        this.$root.$on("call_idexx_iframe", function (lab_response) {
            self.$refs.modalIdexxSubmit.open(lab_response);
        });

        this.$root.$on("privacyPolicyModal", function () {
            self.$refs.privacyWindow.open();
        });

        this.messageListener();

        // -- datetimepicker init
        // eslint-disable-next-line no-undef
        jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
            icons: {
                time: "far fa-clock",
                date: "far fa-calendar",
                up: "fas fa-arrow-up",
                down: "fas fa-arrow-down",
                previous: "fas fa-chevron-left",
                next: "fas fa-chevron-right",
                today: "fas fa-calendar-check",
                clear: "far fa-trash-alt",
                close: "far fa-times-circle"
            }
        });

        // Reset modal data
        this.$root.$on("bv::modal::hidden", (bvEvent /* modalId */) => {
            try {
                assign(
                    bvEvent.vueTarget.$parent.$data,
                    bvEvent.vueTarget.$parent.$options.data()
                );
            } catch (e) {
                console.log(e);
            }
        });
        this.$root.$on("bv::modal::shown", (/* bvEvent, modalId */) => {
            this.$root.$emit("bv::hide::popover");
        });
    },
    sockets: {
        reconnect(/* socket, tryCount */) {
            if (this.setting.business_id) {
                this.registerSocketIO();
            }
        }
    },
    methods: {
        toggleFullscreen() {
            this.$fullscreen.toggle(this.$el, {
                wrap: false,
                callback: this.fullscreenChange
            });
        },
        fullscreenChange(fullscreen) {
            this.fullscreen = fullscreen;
        },
        getBusinesses() {
            let self = this;
            if (self.businesses.length === 0) {
                this.$http
                    .get(process.env.ACTOR_SERVICE + "staff/businesses")
                    .then(function (response) {
                        self.businesses = response.data.response.resources;
                    });
            }
        },
        getCurrentStaff() {
            let self = this;
            return this.$http
                .get(process.env.ACTOR_SERVICE + "staff/current")
                .then(function (response) {
                    self.currentActor = response.data.response.resource.actor;
                    self.timesheet = response.data.response.resource.timesheet;
                    self.$root.currentActor = clone(self.currentActor);
                    self.$root.timesheet = clone(self.timesheet);
                    localStorage.setItem(
                        "my_staff_url",
                        self.$root.currentActor.ci_url
                    );

                    const disableIntercomPages = [
                        "display_treatment",
                        "display_census",
                        "display_appointment"
                    ];

                    if (
                        response.data.response.resource.intercom_data &&
                        !disableIntercomPages.includes(self.$route.name)
                    ) {
                        self.$root.intercomData =
                            response.data.response.resource.intercom_data;
                        IntercomJsSdk(self.$root.intercomData);
                    }

                    return self.$root.currentActor;
                });
        },
        getCurrentStaffPermissions() {
            let self = this;
            return this.$http
                .get(process.env.ACTOR_SERVICE + "staff/current/permissions")
                .then(function (response) {
                    self.permissions = response.data.response.resource;
                    self.$root.permissions = clone(self.permissions);
                });
        },
        async messageListener() {
            let self = this;
            this.$root.$on("message", function (
                message,
                variant,
                duration,
                width,
                params
            ) {
                if (!message) {
                    return;
                }
                self.forceCloseNotifications();

                let icon = null;
                self.width = width ? width : "30%";
                self.notification.variant = variant
                    ? variant
                    : self.notification.variant;

                switch (variant) {
                    case "success":
                        icon = "accept";
                        break;
                    case "danger":
                        icon = "exclamation";
                        break;
                    case "warning":
                        icon = "error";
                        break;
                    case "info":
                        icon = "information";
                        break;
                    default:
                        break;
                }

                message =
                    (icon ? '<i class="cus-' + icon + '"></i>&nbsp;' : "") +
                    message;

                self.$notify({
                    group: "root",
                    duration:
                        duration === true
                            ? -1
                            : duration
                            ? duration
                            : self.notification.duration,
                    closeOnClick: false,
                    text: message
                });

                if (get(params, "close-callback")) {
                    self.$once("close-callback", params["close-callback"]);
                }
            });
        },
        forceCloseNotifications() {
            let notifications = document.getElementsByClassName(
                "vue-notification-wrapper"
            );

            forEach(notifications, function (notification) {
                notification.style.display = "none";
            });
        },
        getBusinessSettings() {
            let self = this;
            // -- https://stackoverflow.com/a/22969338
            let ntp = function (t0, t1, t2, t3) {
                return {
                    roundtripdelay: t3 - t0 - (t2 - t1),
                    offset: (t1 - t0 + (t2 - t3)) / 2
                };
            };
            let t0 = new Date().valueOf();
            return this.$http
                .get(process.env.BARRACUDA + "account/setting")
                .then(response => {
                    self.setting = response.data.response.resource;
                    self.$root.setting = clone(this.setting);

                    let t1 = self.$root.setting.serverTime,
                        t2 = self.$root.setting.serverTime,
                        t3 = new Date().valueOf();

                    self.$root.setting.serverTime = ntp(t0, t1, t2, t3);

                    this.$http
                        .get(
                            process.env.BARRACUDA +
                                "account/setting/currency-symbol"
                        )
                        .then(response => {
                            self.$root.setting.currency_symbol =
                                response.data.response.resource;
                            this.$store.commit(
                                "setCurrency",
                                response.data.response.resource
                            );
                        });
                });
        },
        registerSocketIO() {
            this.$socket.client.emit("v-register", {
                businessId: this.setting.business_id
            });
        },
        closeNotification(props) {
            props.close();
            this.$emit("close-callback");
        },
        getActiveExtension() {
            let self = this;
            return this.$http
                .get(process.env.ACCOUNT_SERVICE + "extension")
                .then(response => {
                    self.extensions = response.data.response.resources;
                    self.$root.extensions = clone(this.extensions);
                    return self.extensions;
                });
        },
        /**
         * Gets called when the clinics have CC processing. Either CCONNECT or
         * STRIPE
         */
        openLock() {
            this.$refs["lockModal"].open();
        },
        showTermsModal() {
            this.$refs.termsWindow.open();
        },
        showPrivacyModal() {
            this.$refs.privacyWindow.open();
        },
        showNewTaskModal() {
            this.$refs.newTaskWindow.open();
        }
    }
};
</script>
<style lang="scss">
@import url("~offline-js/themes/offline-theme-chrome.css");
@import url("~offline-js/themes/offline-language-english.css");

.footer-link {
    color: #7a0000 !important;
    text-decoration: none;
    background-color: transparent;
    cursor: pointer;
}

.footer-links li {
    display: inline;
    margin: 0 0 0 10px;
}

.business-select .box {
    width: 1rem;
    display: inline-block;
}
.notification-text a {
    font-weight: normal !important;
    text-decoration: underline !important;
    color: #222;
}

#nav_module_menu li.nav-item {
    width: 5rem;
    text-align: center;
}

#nav_collapse.show #nav_module_menu li.nav-item {
    width: auto;
    text-align: initial;
    .nav-link.active,
    .nav-link:hover {
        border-radius: 0.6rem;
    }
}
.tvview:fullscreen {
    overflow-y: auto;
}
</style>
